import React, { useEffect, useMemo, useState } from "react";
import api from "../../util/panelApi";
import { PageHead, Chip, fmt } from "./kit";

const LEVELS = [
  ["lvlRoomCover", "Oda arka planı yükleme", "Sesli odaya kapak / arka plan resmi koymak."],
  ["lvlCreateRoom", "Sesli oda açma", ""],
  ["lvlRoomPassword", "Odaya şifre koyma", ""],
  ["lvlGoLive", "Canlı yayın açma", ""],
  ["lvlPrivateMessage", "Özel mesaj gönderme", "Spam'e karşı yeni hesapları sınırlamak için."],
  ["lvlRoomChat", "Oda sohbetine yazma", ""],
  ["lvlLuckyBag", "Şans çantası bırakma", ""],
  ["lvlCreateFamily", "Aile kurma", ""],
  ["lvlMomentPost", "Anlar'da paylaşım", ""],
  ["lvlSendImage", "Sohbette fotoğraf gönderme", "Tek görüntülemelik fotoğraf dahil. VIP3 ve üstü seviyeden muaf."],
  ["lvlVideoParty", "Görüntülü parti açma", "Bu seviyenin altındakiler görüntülü parti odası açamaz (izlemek herkese açık). Yayıncılar seviyeden muaf."],
  ["lvlGames", "Oyun oynama", "Bu seviyenin altındakiler oyunları görmez (yayıncılar ve deneme hesapları hariç)."],
];

const FLAGS = [
  ["liveEnabled", "Canlı yayın", "Kapalıyken kimse yeni canlı yayın açamaz."],
  ["momentsEnabled", "Anlar", "Paylaşım akışı."],
  ["voiceRoomEnabled", "Sesli odalar", "Kapalıyken yeni oda açılamaz."],
  ["chatEnabled", "Özel mesajlaşma", "Kapalıyken yeni mesaj gönderilemez."],
  ["giftsEnabled", "Hediye gönderimi", "Canlı yayın, sesli oda, PK ve profil hediyelerinin hepsi."],
  ["dailyRewardEnabled", "Günlük ödül", "Günlük giriş coin ödülü."],
  ["familyEnabled", "Aileler", "Aile kurma."],
  ["coinBankEnabled", "Yetkili Bayi", "Bayilerin coin göndermesi."],
  ["salaryPolicyEnabled", "Maaş politikası", "Yayıncı ve ajans maaş tablosu. Apple onayından sonra aç. Tablosu açık olan tür (sesli/görüntülü) maaşa geçer; kapalı olan eskisi gibi %60 coin kazandırır."],
  ["storeEnabled", "Mağaza", "Çerçeve / giriş efekti satın alma."],
  ["leaderboardEnabled", "Sıralamalar", "Uygulamada sıralama sayfası görünür."],
  ["eventCenterEnabled", "Etkinlik merkezi", "Uygulamada etkinlikler görünür."],
  ["pkEnabled", "PK düellosu", "Kapalıyken yeni düello daveti gönderilemez."],
  ["liveHostAuthRequired", "Canlı yayın güvenlik kilidi", "Yayıncıya özel işlemler (konuk kabul, anket, efekt) yalnız oturum anahtarıyla yapılır. Yeni sürüm (95+) herkese yayılınca aç; eski sürümdeki yayıncılar bu işlemleri yapamaz."],
  ["liveGuestEnabled", "Canlı yayında konuk katılımı", "İzleyici 'Yayına katıl' ile istek gönderir, yayıncı onaylar. Aynı anda en fazla konuk sayısı Sosyal sekmesinde."],
  ["welcomeRoomPopup", "Açılışta oda önerisi", "Uygulama açılınca 'Odaya katıl' penceresi çıkar. Uygulamanın 83 ve üstü sürümü gerekir."],
  ["luckyBagEnabled", "Şans çantası", "Odalarda coin çantası bırakma."],
  ["relationEnabled", "İlişkiler", "En iyi arkadaş / kardeş / CP istekleri ve profil rozetleri."],
  ["envelopeEnabled", "Kırmızı zarf (özel sohbet)", "Özel sohbette kişiye coin zarfı. 24 saatte açılmazsa iade. Apple onayından sonra aç."],
  ["celebrityEnabled", "Ünlü duvarı", "Yayıncı profilinde pahalı hediyelerin en çok gönderenleri çerçeveli görünür."],
  ["roomBonusEnabled", "Oda roketi", "Odaya gün içinde gelen hediyeler roketi doldurur; seviye dolunca roket kalkar, odadakiler coin kapar. Apple onayından sonra aç."],
  ["gamesEnabled", "Oyunlar", "Menüde oyun listesi görünür."],
  ["screenGuardEnabled", "Ekran koruması", "Açıkken sesli oda ve canlı yayında ekran görüntüsü / kayıt engellenir (Android siyah çıkar, iPhone uyarı verir). Kapatınca serbest; uygulama yeniden açılınca geçerli."],
  ["ayvoBotsEnabled", "AYVO karakter odaları", "10 resmi odada (5 Türkçe, 5 Arapça) 5'er karakter oturur; uygulama boş görünmez. İsimlerinde ᴬʸᵛᴼ işareti var, konuşmaz, hediye ve mesaj almaz, gerçek kullanıcıya yer açar. Kapatınca karakterler kalkar, boş kalan odalar listeden düşer (en geç 3 dk)."],
  ["videoPartyEnabled", "Görüntülü parti", "Kamera odası (4/6/9/12 kamera). Yalnız uygulamanın 104 ve üstü sürümü görür. Açmak için seviye şartı 'Seviye kuralları' sekmesinde; yayıncılar muaf. Agora görüntü ücreti sesliden ~4 kat."],
  ["showcaseHosts", "Vitrin hesapları", "Açıkken admin'den eklenen vitrin (demo) yayıncılar listelerde görünür. Canlı görünmezler; hediye, arama ve mesaj kapalıdır, kimse coin harcayamaz. Gerçek kullanıcılar dolunca kapat."],
  ["androidGoogleLoginEnabled", "Android'de Google girişi", "Açıkken Android giriş ekranında sadece Google butonu görünür (e-posta girişi gizlenir). Firebase'de Play imza anahtarı (0f:4c…) uyarısız olmadan açma; kapalıyken Android'de e-posta girişi var. (Uygulama 44 ve sonrası)"],
  ["facebookLoginEnabled", "Facebook girişi", "Açıkken giriş ekranında \"Ya da\" altında Facebook butonu görünür. Meta uygulaması canlıya alınmadan açma."],
  ["luckyEnabled", "Şanslı hediye çarpanı", "Açıkken hediye alan kişi rastgele katı kadar coin alır — ortalama kat 1'in üstündeyse sistem yoktan coin üretir."],
];

const TABS = [
  ["features", "Özellikler (aç/kapa)"],
  ["room", "Canlı & Sesli oda"],
  ["social", "Sosyal"],
  ["vip", "VIP & Özel ID"],
  ["rewards", "Ödüller"],
  ["luck", "Şans"],
  ["levels", "Seviye kuralları"],
  ["pay", "Ödeme"],
  ["staff", "Yönetim maaşı"],
];

// ozellik anahtarlari kategoriye gore
const FLAG_GROUPS = [
  ["Canlı yayın & sesli oda", ["liveEnabled", "voiceRoomEnabled", "videoPartyEnabled", "ayvoBotsEnabled", "pkEnabled", "giftsEnabled", "liveGuestEnabled", "liveHostAuthRequired", "welcomeRoomPopup"]],
  ["Sosyal", ["chatEnabled", "momentsEnabled", "familyEnabled", "relationEnabled", "celebrityEnabled"]],
  ["Ödül & etkinlik", ["dailyRewardEnabled", "leaderboardEnabled", "eventCenterEnabled"]],
  ["Ekonomi & mağaza", ["storeEnabled", "coinBankEnabled", "salaryPolicyEnabled", "showcaseHosts"]],
  ["Giriş", ["androidGoogleLoginEnabled", "facebookLoginEnabled"]],
  ["Güvenlik", ["screenGuardEnabled"]],
  ["Şans & oyun", ["luckyBagEnabled", "roomBonusEnabled", "envelopeEnabled", "gamesEnabled", "luckyEnabled"], "Apple incelemesinde \"şans oyunu\" sayılabilir — onaydan önce açarken dikkat."],
];

/// Greedy AYVO (kendi coin oyunumuz): ac/kapa, geri donus orani, gerceklesen oran.
const FoodCard = ({ cfg, set, pre = "food", title = "Greedy AYVO (yemek çarkı oyunu)", load = () => api.foodStats() }) => {
  const [st, setSt] = useState(null);
  useEffect(() => {
    load().then((r) => r?.status && setSt(r));
  }, []);
  const k = (x) => pre + x;
  const yuzde = Math.round((Number(cfg[k("Rtp")]) || 0.5) * 100);
  return (
    <div className="card">
      <div className="card-body">
        <div className="d-flex justify-content-between align-items-center">
          <h6 style={{ margin: 0 }}>{title}</h6>
          <label style={{ display: "flex", gap: 6, alignItems: "center", margin: 0, fontSize: 13 }}>
            <input type="checkbox" checked={cfg[k("Enabled")] !== false} onChange={(e) => set(k("Enabled"), e.target.checked)} /> Açık
          </label>
        </div>
        <p style={{ fontSize: 12, color: "#6B7280", margin: "6px 0 10px" }}>
          Oyuncular normal coinle oynar. Geri dönüş oranı: oyunculara uzun vadede yatırılan coinin yüzde kaçı döner. Kalanı kasada kalır. Değişiklik bir sonraki turdan itibaren geçerli.
        </p>
        <div className="d-flex flex-wrap" style={{ gap: 14 }}>
          <div>
            <div style={{ fontSize: 12, fontWeight: 600 }}>Geri dönüş oranı (%)</div>
            <input className="form-control form-control-sm" style={{ width: 110 }} type="number" min="10" max="98" value={yuzde} onChange={(e) => set(k("Rtp"), (Number(e.target.value) || 0) / 100)} />
            <div style={{ fontSize: 11, color: "#6B7280" }}>Kasaya kalan: %{100 - yuzde}</div>
          </div>
          <div>
            <div style={{ fontSize: 12, fontWeight: 600 }}>Bir turda kişi başı en fazla (coin)</div>
            <input className="form-control form-control-sm" style={{ width: 150 }} type="number" min="10" value={cfg[k("MaxBetRound")] ?? 100000} onChange={(e) => set(k("MaxBetRound"), e.target.value)} />
          </div>
        </div>
        {st && (
          <div className="d-flex flex-wrap" style={{ gap: 8, marginTop: 12 }}>
            <Chip kind="ok">Toplam yatırılan: {fmt(st.bet)}</Chip>
            <Chip kind="ok">Ödenen: {fmt(st.paid)}</Chip>
            <Chip kind={st.rtp > st.target + 0.05 ? "bad" : "ok"}>Gerçekleşen oran: %{(st.rtp * 100).toFixed(1)}</Chip>
            <Chip kind="ok">Bugün: {fmt(st.today?.n || 0)} tur · {fmt(st.today?.b || 0)} yatırılan · {fmt(st.today?.p || 0)} ödenen</Chip>
          </div>
        )}
      </div>
    </div>
  );
};

const YummyCard = ({ cfg, set }) => {
  const [st, setSt] = useState(null);
  useEffect(() => {
    api.yummyStats().then((r) => r?.status && setSt(r));
  }, []);
  const yuzde = Math.round((Number(cfg.yummyRtp) || 0.5) * 100);
  return (
    <div className="card">
      <div className="card-body">
        <div className="d-flex justify-content-between align-items-center">
          <h6 style={{ margin: 0 }}>Yummy AYVO (slot oyunu)</h6>
          <label style={{ display: "flex", gap: 6, alignItems: "center", margin: 0, fontSize: 13 }}>
            <input type="checkbox" checked={cfg.yummyEnabled !== false} onChange={(e) => set("yummyEnabled", e.target.checked)} /> Açık
          </label>
        </div>
        <p style={{ fontSize: 12, color: "#6B7280", margin: "6px 0 10px" }}>
          Tek kişilik slot (5x3, 9 çizgi, Wild, Bonus, Jackpot). Normal coinle oynanır. Toplam geri dönüş = oran + jackpot payı. Değişiklik bir sonraki dönüşten itibaren geçerli.
        </p>
        <div className="d-flex flex-wrap" style={{ gap: 14 }}>
          <div>
            <div style={{ fontSize: 12, fontWeight: 600 }}>Çizgi geri dönüş oranı (%)</div>
            <input className="form-control form-control-sm" style={{ width: 110 }} type="number" min="10" max="98" value={yuzde} onChange={(e) => set("yummyRtp", (Number(e.target.value) || 0) / 100)} />
          </div>
          <div>
            <div style={{ fontSize: 12, fontWeight: 600 }}>Jackpot payı (%)</div>
            <input className="form-control form-control-sm" style={{ width: 110 }} type="number" min="0" max="10" step="0.5" value={Math.round((Number(cfg.yummyJackpotPct ?? 0.015)) * 1000) / 10} onChange={(e) => set("yummyJackpotPct", (Number(e.target.value) || 0) / 100)} />
          </div>
          <div>
            <div style={{ fontSize: 12, fontWeight: 600 }}>Jackpot başlangıç (coin)</div>
            <input className="form-control form-control-sm" style={{ width: 150 }} type="number" min="0" value={cfg.yummyJackpotSeed ?? 50000} onChange={(e) => set("yummyJackpotSeed", e.target.value)} />
          </div>
          <div>
            <div style={{ fontSize: 12, fontWeight: 600 }}>Jackpot şansı (1/…)</div>
            <input className="form-control form-control-sm" style={{ width: 130 }} type="number" min="1000" value={cfg.yummyJackpotOdds ?? 40000} onChange={(e) => set("yummyJackpotOdds", e.target.value)} />
          </div>
        </div>
        {st && (
          <div className="d-flex flex-wrap" style={{ gap: 8, marginTop: 12 }}>
            <Chip kind="ok">Toplam yatırılan: {fmt(st.bet)}</Chip>
            <Chip kind="ok">Ödenen: {fmt(st.paid)}</Chip>
            <Chip kind={st.rtp > st.target + 0.05 ? "bad" : "ok"}>Gerçekleşen çizgi oranı: %{(st.rtp * 100).toFixed(1)}</Chip>
            <Chip kind="ok">Jackpot: {fmt(st.jackpot)}</Chip>
            <Chip kind="ok">Bugün: {fmt(st.today?.n || 0)} dönüş · {fmt(st.today?.b || 0)} yatırılan · {fmt(st.today?.p || 0)} ödenen</Chip>
          </div>
        )}
      </div>
    </div>
  );
};

const RocketCard = ({ cfg, set }) => {
  const [st, setSt] = useState(null);
  useEffect(() => {
    api.rocketStats().then((r) => r?.status && setSt(r));
  }, []);
  const yuzde = Math.round((Number(cfg.rocketRtp) || 0.8) * 100);
  return (
    <div className="card">
      <div className="card-body">
        <div className="d-flex justify-content-between align-items-center">
          <h6 style={{ margin: 0 }}>Rocket AYVO (crash oyunu)</h6>
          <label style={{ display: "flex", gap: 6, alignItems: "center", margin: 0, fontSize: 13 }}>
            <input type="checkbox" checked={cfg.rocketEnabled !== false} onChange={(e) => set("rocketEnabled", e.target.checked)} /> Açık
          </label>
        </div>
        <p style={{ fontSize: 12, color: "#6B7280", margin: "6px 0 10px" }}>
          Ortak turlu crash oyunu, normal coinle oynanır. Oran: oyuncu hangi çarpanda çekilirse çekilsin uzun vadede yatırdığının bu kadarı döner. Düşük oran = turların çoğu 1.00x'te anında patlar. Değişiklik bir sonraki turdan itibaren geçerli.
        </p>
        <div className="d-flex flex-wrap" style={{ gap: 14 }}>
          <div>
            <div style={{ fontSize: 12, fontWeight: 600 }}>Geri dönüş oranı (%)</div>
            <input className="form-control form-control-sm" style={{ width: 110 }} type="number" min="10" max="99" value={yuzde} onChange={(e) => set("rocketRtp", (Number(e.target.value) || 0) / 100)} />
            <div style={{ fontSize: 11, color: "#6B7280" }}>Anında patlama: yaklaşık %{100 - yuzde}</div>
          </div>
          <div>
            <div style={{ fontSize: 12, fontWeight: 600 }}>En yüksek çarpan</div>
            <input className="form-control form-control-sm" style={{ width: 110 }} type="number" min="2" value={cfg.rocketMaxMult ?? 1000} onChange={(e) => set("rocketMaxMult", e.target.value)} />
          </div>
          <div>
            <div style={{ fontSize: 12, fontWeight: 600 }}>Turda kişi başı en fazla (coin)</div>
            <input className="form-control form-control-sm" style={{ width: 150 }} type="number" min="100" value={cfg.rocketMaxBetRound ?? 200000} onChange={(e) => set("rocketMaxBetRound", e.target.value)} />
          </div>
        </div>
        {st && (
          <div className="d-flex flex-wrap" style={{ gap: 8, marginTop: 12 }}>
            <Chip kind="ok">Toplam yatırılan: {fmt(st.bet)}</Chip>
            <Chip kind="ok">Ödenen: {fmt(st.paid)}</Chip>
            <Chip kind={st.rtp > st.target + 0.05 ? "bad" : "ok"}>Gerçekleşen oran: %{(st.rtp * 100).toFixed(1)}</Chip>
            <Chip kind="ok">Bugün: {fmt(st.today?.n || 0)} tur · {fmt(st.today?.b || 0)} yatırılan · {fmt(st.today?.p || 0)} ödenen</Chip>
          </div>
        )}
      </div>
    </div>
  );
};

const EconomySettings = () => {
  const [cfg, setCfg] = useState(null);
  const [saving, setSaving] = useState(false);
  const [msg, setMsg] = useState("");
  const [tab, setTab] = useState("features");

  useEffect(() => {
    api.config().then((r) => r?.status && setCfg(r.config));
  }, []);

  const ev = useMemo(() => {
    if (!cfg?.luckyTable) return 0;
    const total = cfg.luckyTable.reduce((s, r) => s + Number(r.weight || 0), 0) || 1;
    return cfg.luckyTable.reduce((s, r) => s + Number(r.multiplier || 0) * (Number(r.weight || 0) / total), 0);
  }, [cfg]);

  if (!cfg) return <div className="badu-empty">Yükleniyor…</div>;

  const set = (k, v) => setCfg({ ...cfg, [k]: v });

  const save = async () => {
    setSaving(true);
    const body = {
      ...cfg,
      dailyCoins: cfg.dailyCoins.map((n) => Number(n) || 0),
      familyCreateCost: Number(cfg.familyCreateCost) || 0,
      bigGiftBannerCoin: Math.max(0, Number(cfg.bigGiftBannerCoin) || 0),
      luckyBagBannerCoin: Math.max(0, Number(cfg.luckyBagBannerCoin) || 0),
      envelopeMin: Math.max(1, Number(cfg.envelopeMin) || 100),
      envelopeMax: Math.max(Number(cfg.envelopeMin) || 100, Number(cfg.envelopeMax) || 100000),
      celebrityGiftMin: Math.max(1, Number(cfg.celebrityGiftMin) || 10000),
      relationCost: Object.fromEntries(["best_friend", "brother", "sister", "cp"].map((k) => [k, Math.max(0, Number((cfg.relationCost || {})[k]) || 0)])),
      roomBonusLevels: (cfg.roomBonusLevels || []).map((r) => ({ need: Math.max(1, Number(r.need) || 0), pool: Math.min(Math.max(0, Number(r.pool) || 0), Math.floor((Number(r.need) || 0) * 0.1)), count: Math.max(1, Math.min(100, Number(r.count) || 1)) })),
      callChargeMin: Math.max(0, Number(cfg.callChargeMin) || 0),
      callChargeMax: Math.max(Number(cfg.callChargeMin) || 0, Number(cfg.callChargeMax) || 0),
      audioCallCharge: Math.max(0, Number(cfg.audioCallCharge) || 0),
      audioMatchCharge: Math.max(0, Number(cfg.audioMatchCharge) || 0),
      firstRechargeBonus: Math.max(0, Number(cfg.firstRechargeBonus) || 0),
      minAge: Math.max(18, Number(cfg.minAge) || 18),
      ...Object.fromEntries(LEVELS.map(([k]) => [k, Math.max(1, Math.min(100, parseInt(cfg[k]) || 1))])),
      luckyTable: cfg.luckyTable.map((r) => ({ ...r, multiplier: Number(r.multiplier), weight: Number(r.weight) })),
      foodRtp: Math.min(0.98, Math.max(0.1, Number(cfg.foodRtp) || 0.5)),
      foodMaxBetRound: Math.max(10, Number(cfg.foodMaxBetRound) || 100000),
      chatPrice: Math.max(1, Number(cfg.chatPrice) || 30),
      chatFreeFirst: Math.max(0, Math.min(50, parseInt(cfg.chatFreeFirst ?? 3) || 0)),
      chatFreeFemale: cfg.chatFreeFemale !== false,
      liveGuestMax: Math.max(1, Math.min(8, parseInt(cfg.liveGuestMax) || 4)),
      fruitRtp: Math.min(0.98, Math.max(0.1, Number(cfg.fruitRtp) || 0.5)),
      fruitMaxBetRound: Math.max(500, Number(cfg.fruitMaxBetRound) || 200000),
      yummyRtp: Math.min(0.98, Math.max(0.1, Number(cfg.yummyRtp) || 0.5)),
      yummyJackpotPct: Math.min(0.1, Math.max(0, Number(cfg.yummyJackpotPct ?? 0.015))),
      yummyJackpotSeed: Math.max(0, Number(cfg.yummyJackpotSeed) || 0),
      yummyJackpotOdds: Math.max(1000, Number(cfg.yummyJackpotOdds) || 40000),
      rocketRtp: Math.min(0.99, Math.max(0.1, Number(cfg.rocketRtp) || 0.8)),
      rocketMaxMult: Math.max(2, Number(cfg.rocketMaxMult) || 1000),
      rocketMaxBetRound: Math.max(100, Number(cfg.rocketMaxBetRound) || 200000),
      staffSalaryCoinPerUsd: Math.max(1, Number(cfg.staffSalaryCoinPerUsd) || 7000),
      staffSalaryTiers: Object.fromEntries(Object.entries(cfg.staffSalaryTiers || {}).map(([k, l]) => [k, (l || []).map((t) => ({ min: Math.max(0, Number(t.min) || 0), rate: Math.max(0, Math.min(100, Number(t.rate) || 0)) })).filter((t) => t.rate > 0).sort((a, b) => a.min - b.min)])),
    };
    const res = await api.saveConfig(body);
    setSaving(false);
    setMsg(res?.status ? "Kaydedildi — uygulamaya hemen yansır." : res?.message || "Kaydedilemedi");
    if (res?.status) setCfg(res.config);
  };

  return (
    <>
      <PageHead
        title="Ekonomi & Özellik Ayarları"
        sub="Uygulamayı güncellemeden özellikleri aç/kapat, ödül ve ücretleri değiştir."
        right={
          <div className="d-flex align-items-center" style={{ gap: 10 }}>
            {msg && <span style={{ fontSize: 13, color: "#6B7280" }}>{msg}</span>}
            <button className="btn btn-primary" onClick={save} disabled={saving}>
              {saving ? "Kaydediliyor…" : "Kaydet"}
            </button>
          </div>
        }
      />
      <div className="d-flex flex-wrap" style={{ gap: 6, marginBottom: 14 }}>
        {TABS.map(([k, l]) => (
          <button key={k} className={`btn btn-sm ${tab === k ? "btn-primary" : "btn-outline-secondary"}`} onClick={() => setTab(k)}>
            {l}
          </button>
        ))}
      </div>
      <div className="row">
        <div className="col-lg-8">
          {tab === "features" && (
            <>
          <div className="card">
            <div className="card-body">
              {FLAG_GROUPS.map(([group, keys, warn]) => (
                <div key={group} style={{ marginBottom: 18 }}>
                  <h6 style={{ marginBottom: 2 }}>{group}</h6>
                  {warn && <div style={{ fontSize: 12, color: "#B45309", marginBottom: 4 }}>{warn}</div>}
                  {FLAGS.filter(([k]) => keys.includes(k)).map(([k, label, hint]) => (
                    <div key={k} className="d-flex justify-content-between align-items-start" style={{ padding: "10px 0", borderBottom: "1px solid #F1F5F9", gap: 12 }}>
                      <div>
                        <b>{label}</b>
                        <div style={{ fontSize: 12, color: "#6B7280" }}>{hint}</div>
                      </div>
                      <button className={`btn btn-sm ${cfg[k] ? "btn-success" : "btn-outline-secondary"}`} style={{ minWidth: 70 }} onClick={() => set(k, !cfg[k])}>
                        {cfg[k] ? "Açık" : "Kapalı"}
                      </button>
                    </div>
                  ))}
                </div>
              ))}
            </div>
          </div>
            </>
          )}
          {tab === "room" && (
            <>
          <div className="card">
            <div className="card-body">
              <h6>Canlı yayın & sesli oda</h6>
              <label style={{ fontSize: 12, color: "#6B7280", }}>Yayıncının kendi belirleyebileceği özel arama ücreti (coin/dk)</label>
              <div className="d-flex" style={{ gap: 8 }}>
                <input className="form-control" type="number" min="0" placeholder="En az" value={cfg.callChargeMin} onChange={(e) => set("callChargeMin", e.target.value)} />
                <input className="form-control" type="number" min="0" placeholder="En çok" value={cfg.callChargeMax} onChange={(e) => set("callChargeMax", e.target.value)} />
              </div>
              <div style={{ fontSize: 12, color: "#6B7280", marginTop: 4 }}>
                Varsayılan dakika ücretleri ve yayıncı payı: Ayarlar → Uygulama Ayarları.
              </div>
              <label style={{ fontSize: 12, color: "#6B7280", marginTop: 10 }}>Sesli arama dakika ücreti (coin/dk). 0 = görüntülü arama ücretinin yarısı</label>
              <input className="form-control" type="number" min="0" value={cfg.audioCallCharge ?? 0} onChange={(e) => set("audioCallCharge", e.target.value)} />
              <label style={{ fontSize: 12, color: "#6B7280", marginTop: 10 }}>Sesli eşleşme dakika ücreti (coin/dk)</label>
              <input className="form-control" type="number" min="0" value={cfg.audioMatchCharge ?? 1400} onChange={(e) => set("audioMatchCharge", e.target.value)} />
              <label style={{ fontSize: 12, color: "#6B7280", marginTop: 10 }}>Büyük hediye şeridi: bu coin ve üstü hediyeler tüm odalarda duyurulur (0 = kapalı)</label>
              <input className="form-control" type="number" min="0" value={cfg.bigGiftBannerCoin} onChange={(e) => set("bigGiftBannerCoin", e.target.value)} />
              <label style={{ fontSize: 12, color: "#6B7280", marginTop: 10 }}>Büyük şans çantası şeridi: bu coin ve üstü çantalar tüm uygulamada duyurulur (0 = kapalı)</label>
              <input className="form-control" type="number" min="0" value={cfg.luckyBagBannerCoin ?? 0} onChange={(e) => set("luckyBagBannerCoin", e.target.value)} />
            </div>
          </div>
          <div className="card">
            <div className="card-body">
              <h6>Bölge kuralı</h6>
              <label style={{ fontSize: 12, color: "#6B7280" }}>
                Sadece kendi ülkesini görecek ülkeler (virgülle ayır, İngilizce ve küçük harf: turkey, egypt…). Boş bırakırsan herkes önce kendi ülkesini, sonra MENA'yı görür.
              </label>
              <input className="form-control" value={cfg.regionOnlyCountries ?? ""} onChange={(e) => set("regionOnlyCountries", e.target.value)} placeholder="turkey" />
            </div>
          </div>
          <div className="card">
            <div className="card-body">
              <h6>Canlı yayın PK</h6>
              <div className="row">
                <div className="col-6 col-md-3">
                  <label style={{ fontSize: 12, color: "#6B7280" }}>x2 süresi (son kaç saniye)</label>
                  <input className="form-control" type="number" min="0" max="120" value={cfg.pkBoostSec ?? 30} onChange={(e) => set("pkBoostSec", e.target.value)} />
                </div>
                <div className="col-6 col-md-3">
                  <label style={{ fontSize: 12, color: "#6B7280" }}>Kaç kat (1 = kapalı)</label>
                  <input className="form-control" type="number" min="1" max="5" value={cfg.pkBoostMultiplier ?? 2} onChange={(e) => set("pkBoostMultiplier", e.target.value)} />
                </div>
                <div className="col-6 col-md-3">
                  <label style={{ fontSize: 12, color: "#6B7280" }}>Gizli skor (son kaç saniye)</label>
                  <input className="form-control" type="number" min="0" max="120" value={cfg.pkShieldSec ?? 30} onChange={(e) => set("pkShieldSec", e.target.value)} />
                </div>
                <div className="col-6 col-md-3">
                  <label style={{ fontSize: 12, color: "#6B7280" }}>Kaybedene ceza (saniye)</label>
                  <input className="form-control" type="number" min="0" max="600" value={cfg.pkPunishSec ?? 60} onChange={(e) => set("pkPunishSec", e.target.value)} />
                </div>
              </div>
              <div style={{ fontSize: 12, color: "#6B7280", marginTop: 6 }}>
                x2 süresinde gelen hediyeler skora kat kat sayılır; yayıncının kazancı ve kullanıcının harcadığı coin değişmez.
              </div>
            </div>
          </div>
          <div className="card">
            <div className="card-body">
              <h6>Oda roketi seviyeleri (en fazla 5)</h6>
              <p style={{ fontSize: 12, color: "#6B7280" }}>
                Odaya gün içinde gelen hediye (yayıncı payı) eşiği geçince roket kalkar ve ödül açılır. Dağıtılan coin eşiğin %10'unu geçemez — sistem coin üretmez. İlerleme her gece sıfırlanır.
              </p>
              <table className="table table-sm">
                <thead>
                  <tr>
                    <th>Seviye</th>
                    <th>Gereken hediye</th>
                    <th>Dağıtılan coin</th>
                    <th>Kaç kişi alır</th>
                  </tr>
                </thead>
                <tbody>
                  {(cfg.roomBonusLevels || []).map((r, i) => {
                    const upd = (k, v) => set("roomBonusLevels", cfg.roomBonusLevels.map((x, j) => (j === i ? { ...x, [k]: v } : x)));
                    return (
                      <tr key={i}>
                        <td>{i + 1}</td>
                        <td><input className="form-control form-control-sm" type="number" min="1" value={r.need} onChange={(e) => upd("need", e.target.value)} /></td>
                        <td><input className="form-control form-control-sm" type="number" min="0" value={r.pool} onChange={(e) => upd("pool", e.target.value)} /></td>
                        <td><input className="form-control form-control-sm" type="number" min="1" max="100" value={r.count} onChange={(e) => upd("count", e.target.value)} /></td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
              <div className="d-flex" style={{ gap: 8 }}>
                {(cfg.roomBonusLevels || []).length < 5 && (
                  <button className="btn btn-sm btn-outline-primary" onClick={() => { const l = cfg.roomBonusLevels || []; const son = l[l.length - 1] || { need: 0 }; set("roomBonusLevels", [...l, { need: (Number(son.need) || 0) * 2 || 20000, pool: 0, count: 20 }]); }}>+ Seviye ekle</button>
                )}
                {(cfg.roomBonusLevels || []).length > 1 && (
                  <button className="btn btn-sm btn-outline-danger" onClick={() => set("roomBonusLevels", cfg.roomBonusLevels.slice(0, -1))}>Son seviyeyi sil</button>
                )}
              </div>
            </div>
          </div>
            </>
          )}
          {tab === "social" && (
            <>
          <div className="card" style={{ marginBottom: 14 }}>
            <div className="card-body">
              <h6 style={{ margin: 0 }}>Canlı yayında en fazla konuk</h6>
              <p style={{ fontSize: 12, color: "#6B7280", margin: "6px 0 10px" }}>Sağdaki konuk kutuları. Her konuk görüntüsü Agora faturasını artırır. 1–8 arası.</p>
              <input className="form-control form-control-sm" style={{ width: 120 }} type="number" min="1" max="8" value={cfg.liveGuestMax ?? 4} onChange={(e) => set("liveGuestMax", e.target.value)} />
            </div>
          </div>
          <div className="card" style={{ marginBottom: 14 }}>
            <div className="card-body">
              <h6 style={{ margin: 0 }}>Oyunları kim görsün</h6>
              <p style={{ fontSize: 12, color: "#6B7280", margin: "6px 0 10px" }}>"Herkes" kapalıysa oyun listesini yalnız işaretli gruplar ve deneme hesapları görür.</p>
              <div className="d-flex flex-wrap" style={{ gap: 18, fontSize: 13 }}>
                {[["everyone", "Herkes"], ["hosts", "Yayıncılar"], ["svip", "SVIP sahipleri"], ["vip", "VIP sahipleri"]].map(([k, t]) => (
                  <label key={k} style={{ display: "flex", gap: 6, alignItems: "center", margin: 0 }}>
                    <input type="checkbox" checked={((cfg.gamesAudience || {})[k]) !== false} onChange={(e) => set("gamesAudience", { ...(cfg.gamesAudience || { everyone: true, hosts: true, svip: true, vip: true }), [k]: e.target.checked })} /> {t}
                  </label>
                ))}
              </div>
            </div>
          </div>
          <div className="card" style={{ marginBottom: 14 }}>
            <div className="card-body">
              <div className="d-flex justify-content-between align-items-center">
                <h6 style={{ margin: 0 }}>Efsane Paket (sınırlı teklif penceresi)</h6>
                <label style={{ display: "flex", gap: 6, alignItems: "center", margin: 0, fontSize: 13 }}>
                  <input type="checkbox" checked={cfg.legendEnabled === true} onChange={(e) => set("legendEnabled", e.target.checked)} /> Açık
                </label>
              </div>
              <p style={{ fontSize: 12, color: "#6B7280", margin: "6px 0 0" }}>
                Günde en fazla 3 kez, en az 2 saat arayla, ilk görünmeden 24 saat geri sayım. Üç paketten yalnız biri alınabilir.
              </p>
            </div>
          </div>
          <div className="card" style={{ marginBottom: 14 }}>
            <div className="card-body d-flex justify-content-between align-items-center" style={{ gap: 10 }}>
              <div>
                <h6 style={{ margin: 0 }}>Yayın bağlantı teşhis kaydı</h6>
                <div style={{ fontSize: 12, color: "#6B7280" }}>Ses/görüntü sorunlarını araştırmak için ayrıntılı Agora kaydı. Normalde kapalı tut; sorun olunca aç, bitince kapat.</div>
              </div>
              <label style={{ display: "flex", gap: 6, alignItems: "center", margin: 0, fontSize: 13, whiteSpace: "nowrap" }}>
                <input type="checkbox" checked={cfg.rtcLog === true} onChange={(e) => set("rtcLog", e.target.checked)} /> Açık
              </label>
            </div>
          </div>
          <div className="card" style={{ marginBottom: 14 }}>
            <div className="card-body">
              <div className="d-flex justify-content-between align-items-center">
                <h6 style={{ margin: 0 }}>Ücretli sohbet (kullanıcı → yayıncı)</h6>
                <label style={{ display: "flex", gap: 6, alignItems: "center", margin: 0, fontSize: 13 }}>
                  <input type="checkbox" checked={cfg.chatPaidEnabled === true} onChange={(e) => set("chatPaidEnabled", e.target.checked)} /> Herkese açık
                </label>
              </div>
              <p style={{ fontSize: 12, color: "#6B7280", margin: "6px 0 10px" }}>
                Kullanıcı yayıncıya yazınca mesaj başına coin düşer, yayıncıya hediyedeki elmas oranı yazılır. Karşılıklı takipte, yayıncı → kullanıcı yönünde, kadın kullanıcılarda, her sohbetin ilk mesajlarında ve destek/yönetim hesaplarında ücretsiz. Yeni uygulama sürümü yayılmadan "Herkese açık"ı açma: eski sürümler "güncelle" uyarısı alır.
              </p>
              <div className="d-flex flex-wrap" style={{ gap: 14 }}>
                <div>
                  <div style={{ fontSize: 12, fontWeight: 600 }}>Mesaj ücreti (coin)</div>
                  <input className="form-control form-control-sm" style={{ width: 120 }} type="number" min="1" value={cfg.chatPrice ?? 30} onChange={(e) => set("chatPrice", e.target.value)} />
                </div>
                <div>
                  <div style={{ fontSize: 12, fontWeight: 600 }}>Her sohbette ücretsiz ilk mesaj</div>
                  <input className="form-control form-control-sm" style={{ width: 120 }} type="number" min="0" value={cfg.chatFreeFirst ?? 3} onChange={(e) => set("chatFreeFirst", e.target.value)} />
                </div>
                <label style={{ display: "flex", gap: 6, alignItems: "center", margin: "18px 0 0", fontSize: 13 }}>
                  <input type="checkbox" checked={cfg.chatFreeFemale !== false} onChange={(e) => set("chatFreeFemale", e.target.checked)} /> Kadın kullanıcılar ücretsiz yazar
                </label>
                <div style={{ flex: 1, minWidth: 220 }}>
                  <div style={{ fontSize: 12, fontWeight: 600 }}>Deneme hesapları (ID, virgülle)</div>
                  <input className="form-control form-control-sm" placeholder="1000, 3085375" value={(cfg.chatPaidTesters || []).join(", ")} onChange={(e) => set("chatPaidTesters", e.target.value.split(",").map((x) => x.trim()).filter(Boolean))} />
                  <div style={{ fontSize: 11, color: "#6B7280" }}>Genel kapalıyken yalnız bu hesaplar ücretli sohbeti görür.</div>
                </div>
              </div>
            </div>
          </div>
          <div className="card">
            <div className="card-body">
              <h6>Sosyal</h6>
              <label style={{ fontSize: 12, color: "#6B7280" }}>Aile kurma ücreti (coin)</label>
              <input className="form-control" type="number" min="0" value={cfg.familyCreateCost} onChange={(e) => set("familyCreateCost", e.target.value)} />
              <label style={{ fontSize: 12, color: "#6B7280", marginTop: 10 }}>Kırmızı zarf: en az / en çok coin</label>
              <div style={{ display: "flex", gap: 8 }}>
                <input className="form-control" type="number" min="1" value={cfg.envelopeMin ?? 100} onChange={(e) => set("envelopeMin", e.target.value)} />
                <input className="form-control" type="number" min="1" value={cfg.envelopeMax ?? 100000} onChange={(e) => set("envelopeMax", e.target.value)} />
              </div>
              <label style={{ fontSize: 12, color: "#6B7280", marginTop: 10 }}>Ünlü duvarı: bu coin ve üstü hediyeler sayılır</label>
              <input className="form-control" type="number" min="1" value={cfg.celebrityGiftMin ?? 10000} onChange={(e) => set("celebrityGiftMin", e.target.value)} />
              <label style={{ fontSize: 12, color: "#6B7280", marginTop: 10 }}>İlişki kurma ücreti (coin, 0 = ücretsiz; reddedilirse iade)</label>
              <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 8 }}>
                {[["best_friend", "En iyi arkadaş"], ["brother", "Erkek kardeş"], ["sister", "Kız kardeş"], ["cp", "CP"]].map(([k, l]) => (
                  <div key={k}>
                    <small style={{ color: "#6B7280" }}>{l}</small>
                    <input className="form-control" type="number" min="0" value={(cfg.relationCost || {})[k] ?? 0} onChange={(e) => set("relationCost", { ...(cfg.relationCost || {}), [k]: e.target.value })} />
                  </div>
                ))}
              </div>
              <label style={{ fontSize: 12, color: "#6B7280", marginTop: 10 }}>Minimum yaş (en az 18)</label>
              <input className="form-control" type="number" min="18" value={cfg.minAge} onChange={(e) => set("minAge", e.target.value)} />
            </div>
          </div>
            </>
          )}
          {tab === "vip" && (
            <>
          <div className="card">
            <div className="card-body">
              <div className="d-flex justify-content-between align-items-center">
                <h6 style={{ margin: 0 }}>VIP1–VIP6 (coin ile)</h6>
                <button className={`btn btn-sm ${cfg.vipClubEnabled ? "btn-success" : "btn-outline-secondary"}`} onClick={() => set("vipClubEnabled", !cfg.vipClubEnabled)}>
                  {cfg.vipClubEnabled ? "Açık" : "Kapalı"}
                </button>
              </div>
              <div style={{ fontSize: 12, color: "#6B7280", margin: "6px 0" }}>Fiyat coin, süre gün. Amblem yüklemezsen uygulama hazır arma çizer.</div>
              <table className="table table-sm">
                <thead><tr><th>Seviye</th><th>Fiyat (coin)</th><th>Gün</th><th>Amblem</th></tr></thead>
                <tbody>
                  {(cfg.vipTiers || []).map((t, i) => {
                    const upd = (k, v) => set("vipTiers", cfg.vipTiers.map((x, j) => (j === i ? { ...x, [k]: v } : x)));
                    return (
                      <tr key={t.level}>
                        <td><b>VIP{t.level}</b></td>
                        <td><input className="form-control form-control-sm" type="number" value={t.price} onChange={(e) => upd("price", Number(e.target.value) || 0)} /></td>
                        <td><input className="form-control form-control-sm" style={{ width: 70 }} type="number" value={t.days} onChange={(e) => upd("days", Number(e.target.value) || 30)} /></td>
                        <td>
                          {t.image && <img src={t.image} alt="" style={{ height: 32, marginRight: 6 }} />}
                          <input
                            type="file"
                            accept="image/*"
                            style={{ width: 150, fontSize: 11 }}
                            onChange={async (e) => {
                              const file = e.target.files?.[0];
                              if (!file) return;
                              const form = new FormData();
                              form.append("image", file);
                              const r = await api.vipImage(t.level, form);
                              if (r?.status) setCfg(r.config);
                            }}
                          />
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
          </div>
          <div className="card">
            <div className="card-body">
              <div className="d-flex justify-content-between align-items-center">
                <h6 style={{ margin: 0 }}>Özel ID satışı</h6>
                <button className={`btn btn-sm ${cfg.customIdEnabled ? "btn-success" : "btn-outline-secondary"}`} onClick={() => set("customIdEnabled", !cfg.customIdEnabled)}>
                  {cfg.customIdEnabled ? "Açık" : "Kapalı"}
                </button>
              </div>
              <div style={{ fontSize: 12, color: "#6B7280", margin: "6px 0" }}>Hane sayısına göre coin fiyatı. 1111, 1234 gibi güzel numaralar otomatik 2 kat.</div>
              <div className="d-flex flex-wrap" style={{ gap: 6 }}>
                {["4", "5", "6", "7", "8", "9"].map((k) => (
                  <div key={k} style={{ width: 110 }}>
                    <label style={{ fontSize: 11, color: "#6B7280" }}>{k} hane</label>
                    <input className="form-control form-control-sm" type="number" value={cfg.customIdPrices?.[k] ?? 0} onChange={(e) => set("customIdPrices", { ...(cfg.customIdPrices || {}), [k]: Number(e.target.value) || 0 })} />
                  </div>
                ))}
              </div>
            </div>
          </div>
            </>
          )}
          {tab === "rewards" && (
            <>
          <div className="card">
            <div className="card-body">
              <h6>Günlük giriş çarkı (12 kutu)</h6>
              <div style={{ fontSize: 12, color: "#6B7280", marginBottom: 6 }}>
                Tür: coin / exp / item. "item" için Mağaza öğesinin ID'sini ve gün sayısını yaz (boşsa kutu gizlenir). Ağırlık = çıkma şansı. 7. günde ödül 2 kat.
              </div>
              <table className="table table-sm">
                <thead><tr><th>#</th><th>Tür</th><th>Miktar / Öğe ID</th><th>Gün</th><th>Ağırlık</th><th>Şans</th></tr></thead>
                <tbody>
                  {(cfg.dailyWheel || []).map((c, i) => {
                    const total = (cfg.dailyWheel || []).reduce((t, x) => t + (Number(x.weight) || 0), 0) || 1;
                    const upd = (k, v) => set("dailyWheel", cfg.dailyWheel.map((x, j) => (j === i ? { ...x, [k]: v } : x)));
                    return (
                      <tr key={i}>
                        <td>{i + 1}</td>
                        <td>
                          <select className="form-control form-control-sm" value={c.type} onChange={(e) => upd("type", e.target.value)}>
                            <option value="coin">coin</option>
                            <option value="exp">exp</option>
                            <option value="item">item</option>
                          </select>
                        </td>
                        <td>
                          {c.type === "item" ? (
                            <input className="form-control form-control-sm" value={c.itemId || ""} onChange={(e) => upd("itemId", e.target.value.trim())} placeholder="Öğe ID" />
                          ) : (
                            <input className="form-control form-control-sm" type="number" value={c.amount || 0} onChange={(e) => upd("amount", Number(e.target.value) || 0)} />
                          )}
                        </td>
                        <td>{c.type === "item" && <input className="form-control form-control-sm" style={{ width: 60 }} type="number" value={c.days || 1} onChange={(e) => upd("days", Number(e.target.value) || 1)} />}</td>
                        <td><input className="form-control form-control-sm" style={{ width: 70 }} type="number" value={c.weight} onChange={(e) => upd("weight", Number(e.target.value) || 0)} /></td>
                        <td>%{(((Number(c.weight) || 0) / total) * 100).toFixed(1)}</td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
          </div>
          <div className="card">
            <div className="card-body">
              <div className="d-flex justify-content-between align-items-center">
                <h6 style={{ margin: 0 }}>Haftalık sıralama ödülleri</h6>
                <button className={`btn btn-sm ${cfg.weeklyRewardsEnabled ? "btn-success" : "btn-outline-secondary"}`} onClick={() => set("weeklyRewardsEnabled", !cfg.weeklyRewardsEnabled)}>
                  {cfg.weeklyRewardsEnabled ? "Açık" : "Kapalı"}
                </button>
              </div>
              <div style={{ fontSize: 12, color: "#6B7280", margin: "6px 0" }}>Her pazartesi 00:00'da geçen haftanın ilk sıralarına otomatik coin ve bildirim gider. Virgülle yaz: 1., 2., 3. …</div>
              {[["weeklyRichRewards", "Zenginlik (en çok hediye gönderen)"], ["weeklyHostRewards", "Yayıncı (en çok hediye alan)"]].map(([k, l]) => (
                <div key={k} style={{ marginTop: 6 }}>
                  <label style={{ fontSize: 12, color: "#6B7280" }}>{l}</label>
                  <input
                    className="form-control form-control-sm"
                    defaultValue={(cfg[k] || []).join(", ")}
                    onBlur={(e) => set(k, e.target.value.split(",").map((x) => Number(x.trim()) || 0).filter((x, i, a) => i < 50))}
                  />
                </div>
              ))}
            </div>
          </div>
            </>
          )}
          {tab === "luck" && (
            <>
          <div className="card">
            <div className="card-body">
              <div className="d-flex justify-content-between align-items-center">
                <h6 style={{ margin: 0 }}>Şanslı hediye tablosu</h6>
                <Chip kind={ev > 1.05 ? "bad" : "ok"}>Ortalama kat: {ev.toFixed(2)}x</Chip>
              </div>
              {ev > 1.05 && (
                <p style={{ fontSize: 12, color: "#B91C1C", marginTop: 8 }}>
                  Ortalama 1x'in üstünde: her 1.000 coinlik hediyede yayıncıya ortalama {fmt(Math.round(ev * 1000))} coin geçer. Fark sistemden çıkar ve çekilebilir kazanca dönüşür.
                </p>
              )}
              <table className="table table-sm" style={{ marginTop: 8 }}>
                <thead>
                  <tr>
                    <th>Etiket</th>
                    <th>Kat</th>
                    <th>Ağırlık</th>
                    <th>Olasılık</th>
                    <th />
                  </tr>
                </thead>
                <tbody>
                  {cfg.luckyTable.map((r, i) => {
                    const total = cfg.luckyTable.reduce((s, x) => s + Number(x.weight || 0), 0) || 1;
                    const upd = (k, v) => set("luckyTable", cfg.luckyTable.map((x, j) => (j === i ? { ...x, [k]: v } : x)));
                    return (
                      <tr key={i}>
                        <td>
                          <input className="form-control form-control-sm" value={r.label} onChange={(e) => upd("label", e.target.value)} />
                        </td>
                        <td>
                          <input className="form-control form-control-sm" type="number" min="1" step="0.1" value={r.multiplier} onChange={(e) => upd("multiplier", e.target.value)} />
                        </td>
                        <td>
                          <input className="form-control form-control-sm" type="number" min="0" step="0.1" value={r.weight} onChange={(e) => upd("weight", e.target.value)} />
                        </td>
                        <td>%{((Number(r.weight || 0) / total) * 100).toFixed(1)}</td>
                        <td>
                          <button className="btn btn-sm btn-outline-danger" onClick={() => set("luckyTable", cfg.luckyTable.filter((_, j) => j !== i))}>
                            ×
                          </button>
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
              <button className="btn btn-sm btn-outline-primary" onClick={() => set("luckyTable", [...cfg.luckyTable, { label: "Yeni", multiplier: 1, weight: 1 }])}>
                Satır ekle
              </button>
            </div>
          </div>
            </>
          )}
          {tab === "levels" && (
            <>
          <div className="card">
            <div className="card-body">
              <h6>Seviye kuralları</h6>
              <div style={{ fontSize: 12, color: "#6B7280", marginBottom: 6 }}>
                Kullanıcının harcama (zenginlik) seviyesi. 1 = herkes yapabilir. Sunucu da kontrol eder, uygulamada kilitli görünür.
              </div>
              {LEVELS.map(([k, label, hint]) => (
                <div key={k} className="d-flex justify-content-between align-items-center" style={{ padding: "8px 0", borderBottom: "1px solid #F1F5F9", gap: 12 }}>
                  <div>
                    <b>{label}</b>
                    {hint && <div style={{ fontSize: 12, color: "#6B7280" }}>{hint}</div>}
                  </div>
                  <div className="d-flex align-items-center" style={{ gap: 6 }}>
                    <span style={{ fontSize: 12, color: "#6B7280" }}>Min. seviye</span>
                    <input className="form-control form-control-sm" style={{ width: 70 }} type="number" min="1" max="100" value={cfg[k] ?? 1} onChange={(e) => set(k, e.target.value)} />
                  </div>
                </div>
              ))}
            </div>
          </div>
            </>
          )}
          {tab === "staff" && (
            <div className="card">
              <div className="card-body">
                <h6>Yönetim maaş kademeleri</h6>
                <div style={{ fontSize: 12, color: "#6B7280", marginBottom: 10 }}>Bölgedeki geçerli ajansların aylık toplamı (USD) hangi kademedeyse o oran uygulanır. Uygulamada Yönetim Paneli'nde görünür. Boş bırakılırsa "belirlenmedi" yazar.</div>
                <label style={{ fontSize: 12, color: "#6B7280" }}>Kaç coin = 1 USD</label>
                <input className="form-control" style={{ maxWidth: 200, marginBottom: 16 }} type="number" value={cfg.staffSalaryCoinPerUsd ?? 7000} onChange={(e) => set("staffSalaryCoinPerUsd", e.target.value)} />
                {[["manager", "Manager"], ["superadmin", "Super Admin"]].map(([rk, ad]) => {
                  const list = (cfg.staffSalaryTiers || {})[rk] || [];
                  const put = (l) => set("staffSalaryTiers", { ...(cfg.staffSalaryTiers || {}), [rk]: l });
                  return (
                    <div key={rk} style={{ marginBottom: 18 }}>
                      <b>{ad}</b>
                      {list.map((t, i) => (
                        <div key={i} className="d-flex align-items-center" style={{ gap: 8, marginTop: 6 }}>
                          <span style={{ width: 30 }}>K{i + 1}</span>
                          <input className="form-control" type="number" placeholder="En az USD" value={t.min} onChange={(e) => put(list.map((x, j) => (j === i ? { ...x, min: e.target.value } : x)))} />
                          <input className="form-control" type="number" placeholder="Oran %" value={t.rate} onChange={(e) => put(list.map((x, j) => (j === i ? { ...x, rate: e.target.value } : x)))} />
                          <span>%</span>
                          <button className="btn btn-sm btn-outline-danger" onClick={() => put(list.filter((_, j) => j !== i))}>Sil</button>
                        </div>
                      ))}
                      <button className="btn btn-sm btn-outline-primary" style={{ marginTop: 8 }} onClick={() => put([...list, { min: "", rate: "" }])}>+ Kademe ekle</button>
                    </div>
                  );
                })}
              </div>
            </div>
          )}
          {tab === "pay" && (
            <>
          <div className="card">
            <div className="card-body">
              <h6>Ödeme (Apple & Google)</h6>
              <label style={{ fontSize: 12, color: "#6B7280" }}>İlk yükleme hediyesi (coin, 0 = kapalı)</label>
              <input className="form-control" type="number" min="0" value={cfg.firstRechargeBonus} onChange={(e) => set("firstRechargeBonus", e.target.value)} />
              <label style={{ fontSize: 12, color: "#6B7280", marginTop: 10 }}>App Store paylaşılan şifre (isteğe bağlı)</label>
              <input className="form-control" type="password" autoComplete="off" value={cfg.appleSharedSecret || ""} onChange={(e) => set("appleSharedSecret", e.target.value)} />
              <label style={{ fontSize: 12, color: "#6B7280", marginTop: 10 }}>Google Play servis hesabı JSON</label>
              <textarea
                className="form-control"
                rows={4}
                placeholder='{"type":"service_account", ...}'
                value={cfg.googlePlayServiceAccount || ""}
                onChange={(e) => set("googlePlayServiceAccount", e.target.value)}
                style={{ fontFamily: "monospace", fontSize: 12 }}
              />
              <div style={{ fontSize: 12, color: "#6B7280", marginTop: 6 }}>
                Coin paketlerinin "Product Key" alanı App Store Connect / Google Play Console'daki ürün kimliğiyle aynı olmalı. Satın almalar sunucuda mağazaya sorularak doğrulanır.
              </div>
            </div>
          </div>
            </>
          )}
        </div>
      </div>
    </>
  );
};

export default EconomySettings;
